/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_Replaces_PainfulInputs */

const en_us2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replaces an exercise that bothered you`)
};

const pt_br2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui um exercício que te incomodou`)
};

const es_419_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza un ejercicio que te molestó`)
};

const pt_pt2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui um exercício que te incomodou`)
};

const fr_fr2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplace un exercice qui te gênait`)
};

const de_de2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzt eine Übung, die dir Beschwerden gemacht hat`)
};

const it_it2_prescription_reason_agent_replaces_painful = /** @type {(inputs: Prescription_Reason_Agent_Replaces_PainfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisce un esercizio che ti dava fastidio`)
};

/**
* | output |
* | --- |
* | "Replaces an exercise that bothered you" |
*
* @param {Prescription_Reason_Agent_Replaces_PainfulInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_replaces_painful = /** @type {((inputs?: Prescription_Reason_Agent_Replaces_PainfulInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_Replaces_PainfulInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_replaces_painful(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_replaces_painful(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_replaces_painful(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_replaces_painful(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_replaces_painful(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_replaces_painful(inputs)
	return en_us2_prescription_reason_agent_replaces_painful(inputs)
});
export { prescription_reason_agent_replaces_painful as "prescription.reason.agent_replaces_painful" }